import { useItem } from './hooks/use-context';

export const Table: React.FC = () => {
  const { sections } = useItem();

  const questions = sections.flatMap((section) => section.questions);

  return (
    <div
      style={{
        backgroundColor: '#FFFFFF',
        marginBottom: '20px',
      }}
    >
      <table
        style={{
          width: '100%',
          borderCollapse: 'collapse',
          border: '1px solid #ddd',
          marginBottom: '20px',
        }}
      >
        <thead>
          <tr>
            <th
              style={{
                border: '1px solid #ddd',
                padding: '8px',
                textAlign: 'center',
                backgroundColor: '#FAE0CD',
                width: '10%',
              }}
            >
              ID
            </th>
            <th
              style={{
                border: '1px solid #ddd',
                padding: '8px',
                textAlign: 'center',
                backgroundColor: '#FAE0CD',
                width: '60%',
              }}
            >
              Descrição
            </th>
            <th
              style={{
                border: '1px solid #ddd',
                padding: '8px',
                textAlign: 'center',
                backgroundColor: '#FAE0CD',
                width: '10%',
              }}
            >
              Eficaz?
            </th>
            <th
              style={{
                border: '1px solid #ddd',
                padding: '8px',
                textAlign: 'center',
                backgroundColor: '#FAE0CD',
                width: '20%',
              }}
            >
              Data da Avaliação
            </th>
          </tr>
        </thead>
        <tbody>
          {[
            '71c456c2-4bfc-4436-a0e4-52b443b895da',
            '7f17cef7-5985-4969-a45e-b3e62c6fb939',
            '36635dd8-6cab-44e3-81e4-4f0fc8f2e77c',
            'e765082e-57a0-4d10-b2e5-926f41d4b9ba',
          ].map((id, index) => {
            const efficiencyAnswer = questions?.find(
              (q) =>
                q.answers.every(
                  (answer) => answer.question_parent_option_id === id,
                ) && q.type === 'radio',
            )?.answers[0];

            const justifyAnswer =
              efficiencyAnswer &&
              questions?.find(
                (q) =>
                  q.answers.every(
                    (answer) =>
                      answer.question_parent_option_id ===
                      efficiencyAnswer.content,
                  ) && q.type === 'text',
              )?.answers[0];

            const observationAnswer = questions?.find(
              (q) =>
                q.answers.every(
                  (answer) => answer.question_parent_option_id === id,
                ) && q.type === 'text',
            )?.answers[0];

            return (
              <tr key={id}>
                <td
                  style={{
                    border: '1px solid #ddd',
                    padding: '8px',
                    textAlign: 'center',
                  }}
                >
                  {(index + 1).toString().padStart(2, '0')}
                </td>
                <td style={{ border: '1px solid #ddd', padding: '8px' }}>
                  {justifyAnswer?.content || ''}
                  {justifyAnswer && observationAnswer ? ' - ' : ''}
                  {observationAnswer?.content || ''}
                </td>
                <td style={{ border: '1px solid #ddd', padding: '8px' }}>
                  <div
                    style={{
                      width: '14px',
                      height: '14px',
                      border: '1px solid #000',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      marginLeft: '21px',
                      fontSize: '12px',
                      lineHeight: '1',
                      color:
                        efficiencyAnswer?.option === 'Sim' ? 'green' : 'red',
                    }}
                  >
                    {efficiencyAnswer
                      ? efficiencyAnswer.option === 'Sim'
                        ? '✔'
                        : 'x'
                      : ''}
                  </div>
                </td>
                <td style={{ border: '1px solid #ddd', padding: '8px' }}>
                  {efficiencyAnswer &&
                    questions.find(
                      (question) =>
                        question.question_id ===
                        '122e4632-0a75-4c40-b136-e9b3a6d8f940',
                    )?.answers?.[0].content}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};
